import React from "react";

export interface RegistrationValues {
  mobile: string;
  code: string;
  name: string;
  acceptedTerms: boolean;
}

interface RegistrationFormProps {
  values: RegistrationValues;
  countdown: number;
  busy: boolean;
  onChange: (next: RegistrationValues) => void;
  onSendCode: () => void;
  onSubmit: () => void;
}

export function RegistrationForm({
  values,
  countdown,
  busy,
  onChange,
  onSendCode,
  onSubmit,
}: RegistrationFormProps) {
  return (
    <form
      className="lawyer-registration-card"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <header>
        <h1>注册平台账号</h1>
        <p>完成手机号验证后，系统将生成登录账号和平台密码。</p>
      </header>
      <label>
        <span>手机号</span>
        <input
          autoComplete="tel"
          inputMode="numeric"
          maxLength={11}
          placeholder="请输入本人手机号"
          value={values.mobile}
          onChange={(event) => onChange({ ...values, mobile: event.target.value.replace(/\D/g, "") })}
        />
      </label>
      <label>
        <span>短信验证码</span>
        <div className="lawyer-registration-code-row">
          <input
            autoComplete="one-time-code"
            inputMode="numeric"
            maxLength={6}
            placeholder="请输入6位验证码"
            value={values.code}
            onChange={(event) => onChange({ ...values, code: event.target.value.replace(/\D/g, "") })}
          />
          <button type="button" disabled={busy || countdown > 0} onClick={onSendCode}>
            {countdown > 0 ? `${countdown}秒后重试` : "获取验证码"}
          </button>
        </div>
      </label>
      <label>
        <span>律师本人姓名</span>
        <input
          autoComplete="name"
          maxLength={64}
          placeholder="请输入真实姓名"
          value={values.name}
          onChange={(event) => onChange({ ...values, name: event.target.value })}
        />
      </label>
      <label className="lawyer-registration-agreement">
        <input
          type="checkbox"
          checked={values.acceptedTerms}
          onChange={(event) => onChange({ ...values, acceptedTerms: event.target.checked })}
        />
        <span>我已阅读并同意《用户协议》和《隐私授权》</span>
      </label>
      <button className="lawyer-registration-primary" type="submit" disabled={busy}>
        {busy ? "正在注册…" : "完成注册"}
      </button>
    </form>
  );
}
